//Online Classes
export const SET_TODAYS_ONLINE_CLASSES = "SET_TODAYS_ONLINE_CLASSES"



